import { RouteFactory } from "@app/routePaths";
import bennet from "@assets/events-awards/ee/img-bennett-wong.jpg";
import christieChu from "@assets/events-awards/ee/img-christiechu.jpg";
import corrando from "@assets/events-awards/ee/img-corradoforcellati.jpg";
import emily from "@assets/events-awards/ee/img-emilyliew.jpg";
import geoffreyyeo from "@assets/events-awards/ee/img-geoffreyyeo.jpg";
import huifen from "@assets/events-awards/ee/img-huifen.jpg";
import iris from "@assets/events-awards/ee/img-iris-ng.jpg";
import jude from "@assets/events-awards/ee/img-jude.jpg";
import quek from "@assets/events-awards/ee/img-quek-kai-hoo.jpg";
import radianasoh from "@assets/events-awards/ee/img-radianasoh.jpg";
import rahul from "@assets/events-awards/ee/img-rahul-sen.png";
import wooesah from "@assets/events-awards/ee/img-wooesah.jpg";
import { AwardsMenu } from "@events-awards/utils/types";
import { TabItem } from "@hooks/useTabs";
import { sectionNavigationItems } from "@util/constant";

export const EVENTS_AWARDS_EE_PATH = RouteFactory.section(
  "events-awards/emerging-enterprise"
);
export const EVENTS_AWARDS_EE_SLOT = EVENTS_AWARDS_EE_PATH.replace("/", "");

export const EVENTS_AWARDS_EE_LABEL =
  sectionNavigationItems[EVENTS_AWARDS_EE_SLOT]?.label;

export const EE_FOOTER_MENU = [
  {
    label: "About",
    link: RouteFactory.eeAboutPage,
  },
  {
    label: "Awards",
    link: RouteFactory.eeAwardsPage,
  },
  {
    label: "Winners",
    link: RouteFactory.eventsAwardsWinners("emerging-enterprise"),
  },
  {
    label: "News",
    link: RouteFactory.eventsAwardsNews("emerging-enterprise"),
  },
  {
    label: "Gallery",
    link: RouteFactory.eventsAwardsGallery("emerging-enterprise"),
  },
  {
    label: "How to Apply",
    link: RouteFactory.eeNominatePage,
  },
  {
    label: "Contact Us",
    link: RouteFactory.eeContactUsPage,
  },
  {
    label: "FAQ",
    link: RouteFactory.eeFaqPage,
  },
  {
    label: "Partners",
    link: RouteFactory.eePartnersPage,
  },
];

export const EE_NAVIGATION_ITEMS: AwardsMenu[] = [
  {
    text: "About",
    link: RouteFactory.eeAboutPage,
    enabled: true,
  },
  {
    text: "Awards",
    link: RouteFactory.eeAwardsPage,
    enabled: true,
  },
  {
    text: "Winners",
    link: RouteFactory.eventsAwardsWinners("emerging-enterprise"),
    enabled: true,
  },
  {
    text: "News",
    link: RouteFactory.eventsAwardsNews("emerging-enterprise"),
    enabled: true,
  },
  {
    text: "Gallery",
    link: RouteFactory.eventsAwardsGallery("emerging-enterprise"),
    enabled: true,
  },
  {
    text: "How to apply",
    link: RouteFactory.eeNominatePage,
    enabled: true,
  },
  {
    text: "APPLY NOW",
    link: RouteFactory.eeApplyNowPage,
    enabled: true,
  },
];

export const NOMINATIONS_TAB: TabItem[] = [
  {
    key: "applicationsTab",
    label: "Application Details",
  },
  {
    key: "eligibilityTab",
    label: "Eligibility Criteria",
  },
  {
    key: "applyTab",
    label: "Steps to Apply",
  },
  {
    key: "termsConditionsTab",
    label: "Terms & Conditions",
  },
];

export const JUDGES_PANEL_LIST = [
  {
    partner: "OCBC Bank",
    name: "Christie Chu",
    position: "Head, Emerging Business International",
    description:
      "Christie leads the Emerging Business (EmB) & Commercial Banking Cash in OCBC Bank. The business serves the growth of SMEs - sole proprietors, partnerships, and private limited companies from start-ups to Serial Entrepreneurs and high growth businesses across multiple industries. It offers a full suite of loans and cash solutions to help the growth of business owners (locally and foreign incorporated entities), including Funds and non-profit organisations. She is responsible for driving acquisition &engagement and digitalisation across the various platforms.",
    imageUrl: christieChu,
  },
  {
    partner: "Global Commercial Banking, OCBC",
    name: "Iris Ng",
    position: "Head, Emerging Business and Commercial Banking Cash",
    description:
      "Iris leads the Emerging Business and Commercial Banking Cash business at OCBC Singapore, focusing on digital-first SME strategies and modernization. She previously led the Middle Market segment and champions financing for high-growth sectors like digital economy and urban solutions. Iris also drives Sustainable Finance, having developed OCBC’s SME Sustainable Finance Framework, now adopted regionally. With over 25 years in commercial banking and deep expertise across industries, she partners with stakeholders to support SMEs in sustainability transitions.",
    imageUrl: iris,
  },
  {
    partner: "The Business Times",
    name: "Chen Hui Fen",
    position: "Editor",
    description:
      "Chen Huifen is the Editor at The Business Times. She started her journalism career at Singapore Press Holdings more than 20 years ago. She has covered macroeconomics, policy, biomedical sciences, healthcare and SMEs before taking on a supervisory role a decade ago.",
    imageUrl: huifen,
  },
  {
    partner: "The Business Times",
    name: "Stanislaus Jude Chan",
    position:
      "Deputy News Editor for Companies & Markets and Environmental, Social & Governance (ESG) issues",
    description:
      "Stanislaus Jude Chan is a deputy news editor at The Business Times, where he oversees the coverage of public listed companies, financial markets, and environmental, social and governance (ESG) issues. Over his career, he has covered real estate investment trusts (Reits) and climate conservation, as well as a range of business topics as a breaking news journalist.",
    imageUrl: jude,
  },
  {
    partner: "Mastercard",
    name: "Rahul Sen",
    position:
      "Vice President Business Development Commercial & New Payment Flows, Asia Pacific",
    description:
      "Rahul is currently the Vice President and Head of Business Development, Commercial Solutions, Asia Pacific at Mastercard. Rahul is a deeply experienced leader with significant expertise in the payments industry. His experience spans Merchant Acquiring, Bank Partnerships and Product Management. However, his specialty is in the Commercial Payment space. He has spent over 2 decades in this field in various leadership roles across many Asian markets including Singapore, Hong Kong, India, Thailand, Malaysia, Indonesia and Philippines.",
    imageUrl: rahul,
  },
  {
    partner: "RSM",
    name: "Woo E-Sah",
    position: "Partner & Head of Assurance",
    description:
      "E-Sah currently leads her firm’s Assurance Practice. She handles assurance, initial public offerings and due diligence assignments for emerging businesses, multinationals, statutory boards, not-for-proﬁt organisations (NPOs) and public-listed companies. E-Sah also serves clients in other industries such as healthcare, shipping, manufacturing, retail and construction.",
    imageUrl: wooesah,
  },
  {
    partner: "RSM",
    name: "Mr Bennett Wong",
    position: "Associate Director and ESG Advisory Practice Leader",
    description:
      "Bennett is RSM Singapore’s ESG Advisory Practice Lead and has experience in corporate sustainability, having previously served as a Senior Manager with the sustainability team at Keppel Limited, working to drive the global asset manager and operator’s net-zero ambitions. Prior to this, he was a Principal consultant with Paia where he led the reporting and sustainability finance function. ",
    imageUrl: bennet,
  },
  {
    partner: "A*STAR",
    name: "Mr Quek Kai Hoo",
    position:
      "Chief Investment Officer, Venture Creation & Growth, Innovation & Enterprise Group ",
    description:
      "Mr Quek Kai Hoo is the Chief Investment Officer of Venture Creation & Growth, Innovation & Enterprise Group responsible for management of A*STAR’s spinoff portfolio and supporting deal structures for new ventures.  Prior to A*STAR, Kai Hoo held many years of investment experience executing deals across venture capital, private equity fund-of-funds and real estate at sovereign wealth fund, venture capital firm and family office. He also has operational experience as general manager of precision engineering firms leading P&L responsibilities.",
    imageUrl: quek,
  },
  {
    partner: "A*STAR",
    name: "Radiana Soh",
    position:
      "Director (Chemical, Materials & Sustainability), Innovation & Enterprise Group",
    description:
      "Radiana leads a team that focuses on technology commercialisation, venture co-creation, licensing and joint collaborations.With more than a decade of experience in technology development and commercialisation, she has taken on a broad spectrum of roles that spans across ideation, marketing, technology matching, productisation, business model formation, negotiations, manufacturing, process improvements and relationship management in partnerships.",
    imageUrl: radianasoh,
  },
  {
    partner: "Enterprise Singapore",
    name: "Emily Liew",
    position: "Assistant Managing Director, Innovation",
    description:
      "Emily is the Assistant Managing Director of Enterprise Singapore, the government agency under the Ministry of Trade & Industry which champions enterprise development. She oversees the Innovation portfolio, covering startup and innovation ecosystem development, enterprise innovation incentives, venture building and global innovation networks. Previously, she led the Strategic Partnerships and Platforms Group, and was formerly Chief Data Officer and Executive Director of Strategic and Corporate Planning.",
    imageUrl: emily,
  },
  {
    partner: "Enterprise Singapore",
    name: "Geoffrey Yeo",
    position:
      "Assistant Managing Director, Capabilities, Urban Systems & Solutions",
    description:
      "Geoffrey is the Assistant Managing Director of Enterprise Singapore, the Singapore government agency which champions enterprise development. He oversees the group responsible for driving enterprise capabilities, in areas like Financing, Sustainability and Digitalisation, to support business growth and competitiveness. He also leads efforts to support the growth of companies in the Urban Systems and Solutions industries. Geoffrey currently serves on the board and investment committee of SEEDS Capital, the investment arm of Enterprise Singapore that catalyses investments into Singapore-based early stage technology startups.",
    imageUrl: geoffreyyeo,
  },
  {
    partner: "Paia Consulting",
    name: "Corrado Forcellati",
    position: "Managing Director",
    description:
      "Corrado guides a skilled and engaged team to help companies in Singapore and Southeast Asia embed sustainability into their strategies and business operations.",
    imageUrl: corrando,
  },
];

export const videoFields = [
  {
    name: "title",
    annotations: [],
    value: "Emerging Enterprise",
  },
  {
    name: "description",
    annotations: [],
    value: "Stars of Emerging Enterprise 2022",
  },
  {
    name: "youtubeId",
    annotations: [],
    value: "Wt94MY9DebY",
  },
  {
    name: "display",
    annotations: [],
    value: "card",
  },
];
